// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svg-icon[data-v-1b718ccb]{color:#41464f;fill:currentColor;overflow:hidden}.svg-icon *[data-v-1b718ccb]{fill:currentColor!important}", ""]);
// Exports
module.exports = exports;
